import * as React from "react";
const CheckIcon = (props) => (
  <svg
    width={35}
    height={35}
    viewBox="0 0 35 35"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_110_10)">
      <circle cx={17.5} cy={17.5} r={17.5} fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2354 9.242C26.7424 9.63485 26.8373 10.3673 26.4472 10.8781L14.8664 26.0448C14.6633 26.3107 14.3561 26.4758 14.0235 26.4975C13.691 26.5193 13.3653 26.3957 13.1296 26.1584L7.33919 20.3251C6.88694 19.8694 6.88694 19.1307 7.33919 18.675C7.79146 18.2195 8.52471 18.2195 8.97698 18.675L13.8348 23.5689L24.6114 9.4554C25.0014 8.94468 25.7285 8.84914 26.2354 9.242Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_110_10">
        <rect width={35} height={35} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CheckIcon;
